module.exports = __webpack_public_path__ + "static/media/airbnb-icon.9f2e01ca.svg";